module.exports = __webpack_public_path__ + "media/styles/images/svg/arrow-up-gray-2ed8d01b496307da48bd59f668c9fcd4.svg";